module.exports = __webpack_public_path__ + "static/media/thuongmaiDetail.6bb9371d.png";